export const NAME = 'selfPromotion';

export const RANKS = ['E5', 'E6'];
